export enum TemplateType {
    TreatmentGiven = 1,
    HistoryNotes = 2,
    OperativeNote = 3,
    TreatmentAdvice = 4,
    Anesthesia = 5,
    DischargeCondition = 6,
    DailyNotes = 7,
    PlanAdvice = 8
}

export const TemplateTypeLabels: Record<TemplateType, string> = {
    [TemplateType.TreatmentGiven]: "Treatment Given",
    [TemplateType.HistoryNotes]: "History Notes",
    [TemplateType.OperativeNote]: "Operative Note",
    [TemplateType.TreatmentAdvice]: "Treatment Advice",
    [TemplateType.Anesthesia]: "Anesthesia",
    [TemplateType.DischargeCondition]: "Discharge Condition",
    [TemplateType.DailyNotes]: "Daily Notes",
    [TemplateType.PlanAdvice]: "Plan / Advice"
};
